import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-generico-view',
  templateUrl: './form-generico-view.component.html',
  styleUrls: ['./form-generico-view.component.css']
})
export class FormGenericoViewComponent {

  @Input() ctxBodyFascicolo;
  constructor() {}
}
